import { Component,OnInit, Inject,EventEmitter,Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ComposableService } from '../services/composable.service';
import { CommonService } from '../services/common.service';

 export  declare const enum SessionStatus {
  ACTIVE = 0,
  WARNING = 1,
  EXPIRED = 2
}
@Component({
  selector: 'confirmation-timeout',
  templateUrl: './confirmation-timeout.component.html',
  styleUrls: []
})
export class ConfirmationTimeoutComponent implements OnInit {
   
  @Output() activateSession: EventEmitter<any>  = new EventEmitter<boolean>();
  @Output() goBackToPortal: EventEmitter<any>  = new EventEmitter<boolean>();
  @Input() public sessionStatus:EventEmitter<SessionStatus>;
  @Input() countDown: EventEmitter<number>;
  @Input() roleIs: string;
  public status: SessionStatus;
  public timeLeft: number=0;
  public counter:string;
  public exitAppText:string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationTimeoutComponent>,
    private composableService: ComposableService,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {

    if (this.countDown) {
      this.countDown.subscribe(result => { this.timeLeft=result; this.counter=this.commonService.toMMSS(result)});
    }

    if (this.sessionStatus) {
      this.sessionStatus.subscribe(result => { this.status=result; });
    }

    if (this.roleIs === 'Agent') {
      this.exitAppText='Return to Sales Hub';
    } else {
      this.exitAppText='Exit Application';
    }
  }

  IsSessionExpired() {
    return(this.status==SessionStatus.EXPIRED);  
  }

  close() {
    this.dialogRef.close();
  }
 
  keepSessionActive() {
    this.activateSession.emit(true);
    this.close();
  }

  backToMiniPortal() {
    
    // erase app memory to prevent old case data from displaying in agent's next case
    this.composableService.resetApplication();

    this.goBackToPortal.emit(true);
    this.close();
  }

}
